import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { AwardIcon, CreateClassIcon } from 'secondstep-components'

export const Wrapper = styled.article`
  max-width: ${themeGet('breakpoints.sizes.large')};
  width: 100%;
  background-color: ${themeGet('colors.paleGray')};
  & header {
    display: block;
    width: 100%;

    & p {
      font-size: 1.0625rem;
    }
  }

  & section {
    color: ${themeGet('colors.cardText')};

    display: block;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    border-radius: ${themeGet('cardBorderRadius')};
    background-color: ${themeGet('colors.white')};
    box-shadow: 0 1px 15px 2px rgba(0, 0, 0, 0.1);
    padding: 1.25rem;
    padding-bottom: 0.625rem;
    ${themeGet('breakpoints.mobile')} {
      flex-direction: column;
    }

    .no-classes {
      text-align: center;
      padding-bottom: 1.25rem;
      .no-class-description {
        font-family: 'SharpSlab-Medium', sans-serif;
        font-weight: 600;
        font-size: 1.375rem;
        color: ${themeGet('colors.themeSecondary')};
        margin: 2.5rem;
        margin-bottom: 1.25rem;
      }

      p {
        margin-bottom: 1.75rem;
      }

      a {
        display: inline-block;
      }

      button {
        padding-right: 1.25rem;
        padding-left: 1.25rem;
      }
    }

    .class-links,
    .course-links {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        margin-right: 1rem;
        margin-top: 0.625rem;
        margin-bottom: 0.625rem;
      }
    }

    /* Course preview buttons: use flex layout with consistent spacing and outlined look */
    .course-links {
      display: flex;
      flex-wrap: wrap;
      gap: 1.25rem;
      padding-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
    .course-links li {
      margin: 0; /* spacing handled by gap */
      flex: 0 0 auto; /* prevent stretching */
    }
    .course-links button {
      min-width: 12rem;
      height: 3rem;
      border-radius: 0.5rem;
      border: none;
      font-weight: 600;
      background-color: ${themeGet(
        'colors.buttons.productPreviewBackground',
        themeGet('colors.themePrimary'),
      )};
      color: ${themeGet('colors.white')};
      width: auto;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
    .course-links button:hover {
      background-color: ${themeGet('colors.themeHighlight')};
    }

    /* Add space between the Tier 1 button row and the Tier 2 header */
    .course-links + h3 {
      margin-top: 1.25rem; /* 20px */
    }

    /* Tier headings (Tier 1 Lessons / Tier 2 Lessons) */

    & header {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 2px solid ${themeGet('colors.paleGray')};
      padding-bottom: 1rem;
      margin-bottom: 0.625rem;
      width: 100%;

      .header-text {
        display: block;
        flex-grow: 1;

        .headline {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          .spacer {
            flex-grow: 1;
          }
          .tier-label {
            margin-bottom: 0.5rem;
          }
        }
      }

      & .spot {
        display: flex;
        color: ${themeGet('colors.themePrimary')};
        svg {
          margin-right: 1rem;
          width: 3rem;
          height: 3rem;
        }
      }
    }

    /* Style for Tier headings (HeaderThree instances immediately inside section bodies) */
    > h3 {
      font-family: ${themeGet('font.sharpSlab.semibold', 'SharpSlab-Semibold')};
      font-weight: 600;
      font-size: 1.125rem; /* 18px */
      line-height: 1; /* 100% */
      margin-top: 1.25rem;
    }
  }

  /* Width overrides per tier for preview buttons */
  .course-links.tier-1 button {
    min-width: 6.875rem; /* 110px */
  }
  .course-links.tier-2 button {
    min-width: 8rem; /* 128px */
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
`

export const StyledButton = styled.button`
  width: 18.5rem;
  height: 3.063rem;
  border-radius: 0.625rem;
  border: none;
  cursor: pointer;
  color: ${themeGet(
    'firstTimeClasses.button.color',
    themeGet('colors.darkBlue'),
  )};
  background-color: ${themeGet('colors.paleGray')};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StyledCreateClassIcon = styled(CreateClassIcon)`
  width: 1.125rem;
  height: 1.125rem;
  margin-left: 0.625rem;
  color: inherit;
  circle {
    fill: currentColor;
  }
`

export const StyledAwardIcon = styled(AwardIcon)`
  width: 0.938rem;
  height: 1.313rem;
  margin-left: 0.625rem;
  color: inherit;
`
